
export const PublicSellerFaqQuery = new TypedDocumentString(`
    query PublicSellerFaqQuery($sellerId: ObjectId!) {
  publicSellerFaq(sellerId: $sellerId) {
    id
    section {
      sellerId
      slug
      title {
        value
        __typename
      }
      __typename
    }
    questions {
      ...SellerFaqQaSmall
      __typename
    }
    __typename
  }
}
    fragment SellerFaqQaSmall on SellerFaqQa {
  slug
  title {
    value
    __typename
  }
  text {
    value
    __typename
  }
  __typename
}`, {"hash":"a706e434039ce8a9a3c02f8c79842cf5090eed8c659c708ec6b9913ab89ef7b1"});